<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="SupplierModalLabel">Add</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal needs-validation" novalidate id="formAddSupplier">
        <!-- Row -->
        <div class="row">
          <!-- Column -->
          <div class="col-lg-6 col-xlg-6 col-md-6">
            <div class="mb-3">
              <label class="col-md-12">Code</label>
              <div class="col-md-12">
                <input type="text" class="form-control" v-model="code" required />
                <div class="invalid-feedback">
                  Please enter code.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Name</label>
              <div class="col-md-12">
                <input type="text" class="form-control" v-model="name" required />
                <div class="invalid-feedback">
                  Please enter name.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Tel</label>
              <div class="col-md-12">
                <input type="text" v-model="tel" class="form-control" />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Email</label>
              <div class="col-md-12">
                <input type="email" class="form-control" v-model="email" />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Address</label>
              <div class="col-md-12">
                <textarea type="text" class="form-control" v-model="address"></textarea>
              </div>
            </div>
          </div>
          <!-- Column -->
          <!-- Column -->
          <div class="col-lg-6 col-xlg-6 col-md-6">
            <div class="mb-3">
              <label class="col-md-12">Plant Code</label>
              <div class="col-md-12">
                <input type="text" v-model="plantcode" class="form-control" required />
                <div class="invalid-feedback">
                  Please enter plant code.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Fullname</label>
              <div class="col-md-12">
                <input type="text" class="form-control" v-model="fullname" required />
                <div class="invalid-feedback">
                  Please enter fullname.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Fax</label>
              <div class="col-md-12">
                <input type="text" class="form-control" v-model="fax" />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Tax</label>
              <div class="col-md-12">
                <input type="text" class="form-control" v-model="tax" />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Note</label>
              <div class="col-md-12">
                <textarea type="text" class="form-control" v-model="note"></textarea>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
        <!-- Row -->
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-fix" data-bs-dismiss="modal" id="supplierModalclose"><i class="fa fa-times"></i> Close</button>
      <button type="button" class="btn btn-info btn-fix" @click="checkForm" id="submitbtn"><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/supplier'

export default {
  props: ['loadNewsupplier'],
  data() {
    return {
      code: '',
      name: '',
      fullname: '',
      plantcode: '',
      address: '',
      tel: '',
      fax: '',
      email: '',
      tax: '',
      note: ''
    }
  },
  methods: {
    checkForm() {
      if (this.code !== '' && this.name !== '' && this.fullname !== '' && this.plantcode !== '') {
        this.insertSupplier()
      } else {
        // eslint-disable-next-line no-undef
        $('#formAddSupplier').addClass('was-validated')
      }
    },
    insertSupplier() {
      // $('#supplierModalclose').click()
      $('.preloader').fadeIn()
      let formData = {
        code: this.code,
        name: this.name,
        fullname: this.fullname,
        plantcode: this.plantcode,
        address: this.address,
        tel: this.tel,
        fax: this.fax,
        email: this.email,
        tax: this.tax,
        note: this.note
      }
      api.addSupplier(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.loadNewsupplier()
            this.alert_msg('success', 'Successful', result.message)
            $('.preloader').fadeOut()
            $('#SupplierModal').modal('hide')
          } else {
            this.loadNewsupplier()
            this.alert_msg('warning', 'An error occurred.', result.message)
            $('.preloader').fadeOut()
            $('#SupplierModal').modal('hide')
          }
        },
        error => {
          this.loadNewsupplier()
          this.alert_msg('error', 'An error occurred.', error.message)
          $('.preloader').fadeOut()
          $('#SupplierModal').modal('hide')
        }
      )
    }
  },
  mounted() {
    var myModalEl = document.getElementById('SupplierModal')
    myModalEl.addEventListener('shown.bs.modal', event => {
      this.code = ''
      this.name = ''
      this.fullname = ''
      this.plantcode = ''
      this.address = ''
      this.tel = ''
      this.fax = ''
      this.email = ''
      this.tax = ''
      this.note = ''
      $('#formAddSupplier').removeClass('was-validated')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/supplier_add_modal.vue